module.exports = __webpack_public_path__ + "static/media/discover.0dbbeeb8.svg";